import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import { useHistory, useLocation } from 'react-router-dom';

import { ROUTES } from 'config/constants';

import RiseTicket from '../RiseTicket/RiseTicket';
import Button from 'containers/App/components/Button/Button';
import ReturnProduct from '../ReturnProduct';
import UpdateRentalTerms from './UpdateRentalTerms';

import { notifType, notify } from 'utils/notifSender';

import { getAuthedProfile } from 'api/user';

import buy from 'assets/images/general/buy.svg';

import style from './ProductActions.module.scss';

ProductActions.propTypes = {
    handleRiseTicket: PropTypes.func,
    submitLoading: PropTypes.bool,
    rentalOptions: PropTypes.array,
    selectedRentalPeriod: PropTypes.object,
    setSelectedRentalPeriod: PropTypes.func,
    changeRentalTerms: PropTypes.func,
    handleBuyNow: PropTypes.func,
    price: PropTypes.string,
    handleReturnOrder: PropTypes.func,
    order: PropTypes.any,
    isOpenFirst: PropTypes.bool,
    setIsOpenFirst: PropTypes.func,
    isOpenSecond: PropTypes.bool,
    setIsOpenSecond: PropTypes.func,
    componnetType: PropTypes.any,
    setComponnetType: PropTypes.func,
    riseTicket: PropTypes.object,
    setRiseTicket: PropTypes.func,
    returnOrderType: PropTypes.string,
    setReturnOrderType: PropTypes.func,
    product: PropTypes.object
};

function ProductActions({
    handleRiseTicket,
    submitLoading,
    rentalOptions,
    selectedRentalPeriod,
    setSelectedRentalPeriod,
    changeRentalTerms,
    order,
    isOpenFirst,
    setIsOpenFirst,
    isOpenSecond,
    setIsOpenSecond,
    componnetType,
    setComponnetType,
    riseTicket,
    setRiseTicket,
    product
}) {
    const history = useHistory();
    const { state } = useLocation();
    const [open, setOpen] = useState(false);
    const [disable, setDisable] = useState(false);
    const [formattedData, setFormattedData] = useState([]);

    const handleRental = i => setSelectedRentalPeriod(i);

    const handleFirstCollapse = (e) => {
        setIsOpenFirst(false);
        setComponnetType(e);
        setTimeout(() => setIsOpenFirst(true), 100);
        setIsOpenSecond(false);
    };

    const handleSecondCollapse = (e) => {
        setIsOpenSecond(false);
        setComponnetType(e);
        setTimeout(() => setIsOpenSecond(true), 100);
        setIsOpenFirst(false);
    };

    const handleBuy = () => history.push(ROUTES.PRODUCTORDERSUMMARY(product?.id, order?.id, order?.order_number, true));

    const handleRentalTermSubmit = () => {
        if (selectedRentalPeriod.id === -1) {
            notify('Please select a rental option.', notifType.DANGER);

            return true;
        }

        changeRentalTerms();
    };

    useEffect(() => {
        if (state && state.rentId && state.rentId.length) {
            setSelectedRentalPeriod(state.rentId?.[0]);
        }
    }, [state, setSelectedRentalPeriod]);

    useEffect(() => {
        const fetchData = async () => {
            const profileData = await getAuthedProfile();

            let userType = 'b2c';

            if (profileData?.data?.is_student) {
                userType = 'b2s';
            }

            const rentalPeriods = rentalOptions.filter(option =>
                option.user_type === userType && option.duration_time !== 1
            );

            const defaultRentalPeriods = rentalOptions.filter(option => option.duration_time !== 1);

            setFormattedData(rentalPeriods?.length > 0 ? rentalPeriods : defaultRentalPeriods);
        };

        fetchData();
    }, [rentalOptions]);

    // const durationLeftInMonths = () => {
    //     const currentDate = new Date();
    //     const deliveredDate = new Date(order?.delivered_at);
    //     const subscriptionEndsDate = new Date(order?.ends_at);
    //     const subscriptionLeft = Math.abs(currentDate.getTime() - deliveredDate.getTime());
    //     const actualSubscriptionPeriod = getRentalPeriod();
    //     const subscriptionLeftInMonths = subscriptionEndsDate > currentDate ? Math.ceil(subscriptionLeft / (2e3 * 3600 * 365.25)) : actualSubscriptionPeriod;
    //     const diffInMonthsWithSubscriptionLeft = Number(getRentalPeriod()) - Number(subscriptionLeftInMonths);

    //     return diffInMonthsWithSubscriptionLeft < 0 ? 0 : diffInMonthsWithSubscriptionLeft;
    // };

    return (<div className={style.section}>
        <ReturnProduct
            setDisable={setDisable}
            open={open}
            handleClose={setOpen}
            order={order}
            product={product} />

        <div className={style.ctaBtns}>
            <Button
                onClick={() => !isOpenSecond ? handleSecondCollapse('ticket') : setIsOpenSecond(false)}
                title={'Report an Issue'}
                className={(componnetType === 'ticket' ? 'submit ' : 'ignore ') + style.btnOutline} />
            <Button
                loading={submitLoading}
                disabled={!order?.can_be_purchased}
                onClick={!order?.can_be_purchased ? () => { } : () => handleBuy()}
                title={<span className={style.productactionBtn__title}>
                    {!order.is_purchased && <img className={style.productactionBtn__title__img} src={buy} alt='Buy icon' />}
                    <span className={style.productactionBtn__title__label}>Buy</span>
                </span>} className={(componnetType === 'buy' ? 'submit ' : 'ignore ') + style.btnFilled} />
            {/* <Button
                disabled={!order.can_be_returned || disable}
                onClick={() => setOpen(true)}
                title={'Return?'}
                className={style.return + ' ' + style.btnFilled} /> */}
        </div>

        <Button
            disabled={!order.can_be_updated || disable}
            onClick={() => !isOpenFirst ? handleFirstCollapse('rental') : setIsOpenFirst(false)}
            className={style.changeSubscription}
            title={'Change Subscription or Return?'} />

        <Collapse isOpen={isOpenFirst}>
            <div className={style.rentalOptionsContainer}>
                <p className={style.title}>Select new terms</p>
                <div className={style.durations}>
                    {formattedData.map((option, i) => {
                        return <div key={i}
                            className={`${style.duration} ${selectedRentalPeriod.id === option.id ? style.activeDuration : ''}`}
                            onClick={() => handleRental(option)}>
                            {option.duration_time} Month{option.duration_time > 1 && 's'}
                        </div>;
                    })}
                </div>
                <UpdateRentalTerms order={order} selectedRentalPeriod={selectedRentalPeriod} product={product} />
                <div className={style.ctaBtns}>
                    <Button
                        disabled={!order.can_be_returned || disable}
                        onClick={() => setOpen(true)}
                        title={'Return?'}
                        className={style.return + ' ' + style.btnFilled} />
                    <Button
                        loading={submitLoading}
                        disabled={!order.can_be_updated}
                        onClick={() => handleRentalTermSubmit()}
                        className={`w-100 ${style.btnFilled}`}
                        title={'Update'} />
                </div>
            </div>
        </Collapse>

        <Collapse className={style.collapse} isOpen={isOpenSecond}>
            {componnetType === 'ticket' &&
                <RiseTicket
                    riseTicket={riseTicket}
                    setRiseTicket={setRiseTicket}
                    onClick={handleRiseTicket}
                    submitLoading={submitLoading} />
            }
        </Collapse>
    </div>);
}

export default ProductActions;
